import { render, staticRenderFns } from "./ObsHourText.vue?vue&type=template&id=861a1814&scoped=true&"
import script from "./ObsHourText.vue?vue&type=script&lang=js&"
export * from "./ObsHourText.vue?vue&type=script&lang=js&"
import style0 from "./ObsHourText.vue?vue&type=style&index=0&id=861a1814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861a1814",
  null
  
)

export default component.exports